<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-lg modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <span>Send Counter Offer to {{ negotiation.carrier.company }}</span>
            <button @click="onClose" type="button" class="close" data-bs-dismiss="modal" aria-label="Close">×</button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <div class="alert alert-info">
                <strong>Current Offer:</strong> ${{ negotiation.latestCarrierOffer.carrierPay }}
                <span class="ml-2">
                  (Pickup: {{ negotiation.latestCarrierOffer.pickupDate | formatDate }},
                  Delivery: {{ negotiation.latestCarrierOffer.deliveryDate | formatDate }})
                </span>
                <div v-if="negotiation.latestCarrierOffer.expiresAt" class="mt-1">
                  <small :class="isExpired ? 'text-danger' : 'text-muted'">
                    {{ isExpired ? 'Expired' : 'Expires' }} at: {{ negotiation.latestCarrierOffer.expiresAt | formatDateTime }}
                  </small>
                </div>
              </div>
            </div>

            <div v-if="errors.generalError" class="alert alert-danger">{{ errors.generalError }}</div>

            <form @submit.prevent="submit()">
              <b-form-group label="Counter Offer Amount" class="required">
                <b-input
                  v-model="form.carrierPay"
                  type="number"
                  step="0.01"
                  placeholder="Enter your counter offer"
                  :class="{'is-invalid': errors.carrier_pay}"
                  required
                />
                <div v-if="errors.carrier_pay" class="invalid-feedback d-block">{{ errors.carrier_pay[0] }}</div>
              </b-form-group>

              <b-form-group label="Pickup Date" class="required">
                <flat-pickr
                  v-model="form.pickupDate"
                  placeholder="Select pickup date"
                  :config="pickupConfig"
                  :class="{'is-invalid': errors.pickup_date}"
                />
                <div v-if="errors.pickup_date" class="invalid-feedback d-block">{{ errors.pickup_date[0] }}</div>
              </b-form-group>

              <b-form-group label="Delivery Date" class="required">
                <flat-pickr
                  v-model="form.deliveryDate"
                  placeholder="Select delivery date"
                  :config="deliveryConfig"
                  :class="{'is-invalid': errors.delivery_date}"
                />
                <div v-if="errors.delivery_date" class="invalid-feedback d-block">{{ errors.delivery_date[0] }}</div>
              </b-form-group>

              <b-form-group label="Note (Optional)">
                <b-textarea
                  v-model="form.note"
                  placeholder="Add a note to the carrier..."
                  rows="3"
                />
              </b-form-group>

              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary mr-2" @click="onClose">Cancel</button>
                <button class="btn btn-primary" type="submit" :disabled="formSubmit || isExpired">
                  {{ formSubmit ? 'Sending...' : 'Send Counter Offer' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';

export default {
  name: 'CounterOfferModal',
  props: {
    order: {
      type: Object,
      required: true,
    },
    negotiation: {
      type: Object,
      required: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      formSubmit: false,
      errors: {},
      form: {
        carrierPay: this.negotiation.latestCarrierOffer.carrierPay || '',
        pickupDate: this.negotiation.latestCarrierOffer.pickupDate || '',
        deliveryDate: this.negotiation.latestCarrierOffer.deliveryDate || '',
        note: '',
      },
      pickupConfig: {
        inline: false,
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
        allowInput: false,
      },
      deliveryConfig: {
        inline: false,
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
        allowInput: false,
      },
    };
  },
  computed: {
    isExpired() {
      if (!this.negotiation.latestCarrierOffer.expiresAt) return false;
      return new Date(this.negotiation.latestCarrierOffer.expiresAt) < new Date();
    },
  },
  methods: {
    async submit() {
      if (this.isExpired) {
        this.errors = { generalError: 'This offer has expired and cannot be countered.' };
        return;
      }

      this.formSubmit = true;
      this.errors = {};

      const response = await ApiClient.leads.offers.counter({
        leadId: this.order.id,
        id: this.negotiation.latestCarrierOffer.id,
        body: {
          carrier_pay: parseFloat(this.form.carrierPay),
          pickup_date: this.form.pickupDate,
          delivery_date: this.form.deliveryDate,
          note: this.form.note || undefined,
        },
      });

      if (response.status === 200) {
        this.$bvToast.toast('Counter offer sent successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });
        this.$emit('refresh');
        this.onClose();
      } else if (response.status === 400) {
        this.errors = { generalError: response.data.message };
      } else if (response.status === 422) {
        this.errors = response.data.errors;
      } else {
        this.errors = { generalError: 'An error occurred. Please try again.' };
      }

      this.formSubmit = false;
    },
  },
  watch: {
    'form.pickupDate': function (val) {
      this.deliveryConfig.minDate = val;
    },
  },
};
</script>

<style lang="scss" scoped>
h5 {
  margin: 0;
}

.outter-modal {
  position: absolute;
  z-index: 1089;
}

.required label::after {
  content: ' *';
  color: #dc3545;
}
</style>
